/**
 * Iter130 — CLIENTS hub.
 *
 * Consolidates the previously-separate top-level tiles:
 *   Nexus Clients  (client roster)
 *   Client Intakes (intake queue)
 *   Client Requests (client-portal requests)
 *
 * Rendered as a single tabbed page under /clients so the Modules
 * Menu Box only exposes one entry point.
 */
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Users, Inbox, ClipboardList } from 'lucide-react';
import Clients from './Clients';
import Intakes from './ClientIntakes';
import ClientRequestCenter from './ClientRequestCenter';

export default function ClientsHub() {
  const [tab, setTab] = useState('roster');
  return (
    <div className="space-y-4" data-testid="clients-hub-page">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-lg bg-cyan-500/20 border border-cyan-500/40 flex items-center justify-center">
          <Users className="w-6 h-6 text-cyan-300" />
        </div>
        <div>
          <div className="text-xs text-cyan-300 uppercase tracking-wider font-mono">NexusTrac · Clients Hub</div>
          <h1 className="text-2xl font-bold text-white">Clients</h1>
          <p className="text-slate-400 text-sm">Roster, intake queue, and inbound client requests — in one place.</p>
        </div>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="bg-[#131A2A] border border-[#334155]">
          <TabsTrigger value="roster" data-testid="tab-clients-roster">
            <Users className="w-4 h-4 mr-1" /> Client Roster
          </TabsTrigger>
          <TabsTrigger value="intakes" data-testid="tab-clients-intakes">
            <ClipboardList className="w-4 h-4 mr-1" /> Client Intakes
          </TabsTrigger>
          <TabsTrigger value="requests" data-testid="tab-clients-requests">
            <Inbox className="w-4 h-4 mr-1" /> Client Requests
          </TabsTrigger>
        </TabsList>
        <TabsContent value="roster" className="mt-4"><Clients /></TabsContent>
        <TabsContent value="intakes" className="mt-4"><Intakes /></TabsContent>
        <TabsContent value="requests" className="mt-4"><ClientRequestCenter /></TabsContent>
      </Tabs>
    </div>
  );
}
